'use client'

import { useScrollbarSize } from '@landfolk/shared/utils/useScrollbarSize'

export function ScrollbarSizeStyles() {
  const scrollbarSize = useScrollbarSize()

  return (
    <style jsx global>{`
      :root {
        --scrollbar-size: ${scrollbarSize ?? 0}px;
        --ui-bottom-safe-inset: calc(env(safe-area-inset-bottom, 0) / 2);
      }
    `}</style>
  )
}
